<template>
  <div class="form form-card">
    <div class="form-card__container">
      <el-form
        ref="RegisterForm"
        class="register__form"
        :model="RegisterForm"
        :rules="RegisterRules"
        @submit.prevent.native
      >
        <!-- 信箱 -->
        <el-form-item prop="memberMail" class="form-field">
          <label class="form-label">{{ $t('register.label.email') }}</label>
          <el-input
            v-model="RegisterForm.memberMail"
            :placeholder="$t('register.placeholder.email')"
            size="large"
            prefix-icon="el-icon-message"
          />
          <p class="form-note">{{ $t('register.note.emailIsAccount') }}</p>
        </el-form-item>

        <!-- 信箱驗證碼 -->
        <div class="form-group form-group--inline">
          <el-form-item prop="mailVerificationCaptchaCode" class="form-field form-field--flex">
            <label class="form-label">{{ $t('register.label.emailCode') }}</label>
            <el-input
              v-model="RegisterForm.mailVerificationCaptchaCode"
              :placeholder="$t('register.placeholder.emailCode')"
              size="large"
              prefix-icon="el-icon-key"
            />
          </el-form-item>
          <el-button
            type="success"
            size="large"
            :disabled="mailTimerText !== $t('register.button.sendCode')"
            class="btn-action"
            @click="GetVerification(1)"
          >
            <i class="el-icon-s-promotion"></i>
            {{ mailTimerText }}
          </el-button>
        </div>

        <!-- 密碼 -->
        <div class="form-group form-group--grid-2">
          <el-form-item prop="memberPassword" class="form-field">
            <label class="form-label">{{ $t('register.label.password') }}</label>
            <el-input
              v-model="RegisterForm.memberPassword"
              :placeholder="$t('register.placeholder.password')"
              type="password"
              size="large"
              prefix-icon="el-icon-lock"
              show-password
            />
          </el-form-item>

          <el-form-item prop="memberConfirmPassword" class="form-field">
            <label class="form-label">{{ $t('register.label.confirmPassword') }}</label>
            <el-input
              v-model="RegisterForm.memberConfirmPassword"
              :placeholder="$t('register.placeholder.confirmPassword')"
              type="password"
              size="large"
              prefix-icon="el-icon-lock"
              show-password
            />
          </el-form-item>
        </div>

        <!-- 姓名與電話 -->
        <div class="form-group form-group--grid-2">
          <el-form-item prop="memberName" class="form-field">
            <label class="form-label">{{ $t('register.label.name') }}</label>
            <el-input
              v-model="RegisterForm.memberName"
              :placeholder="$t('register.placeholder.name')"
              size="large"
              prefix-icon="el-icon-user"
            />
          </el-form-item>

          <el-form-item prop="memberPhone" class="form-field">
            <label class="form-label">{{ $t('register.label.phone') }}</label>
            <el-input
              v-model="RegisterForm.memberPhone"
              :placeholder="$t('register.placeholder.phone')"
              size="large"
              prefix-icon="el-icon-phone"
            />
          </el-form-item>
        </div>

        <!-- 地址 -->
        <div class="form-group">
          <label class="form-label">{{ $t('register.label.address') }}</label>
          <div class="form-address">
            <div class="form-address__zipCode">
              <el-form-item prop="memberZipCode" class="form-field">
                <el-input
                  v-model="RegisterForm.memberZipCode"
                  :placeholder="$t('register.placeholder.zipCode')"
                  size="large"
                  disabled
                />
              </el-form-item>
            </div>

            <div class="form-address__county">
              <el-form-item prop="memberCounty" class="form-field">
                <el-select
                  v-model="RegisterForm.memberCounty"
                  :placeholder="$t('register.placeholder.county')"
                  size="large"
                  @change="SetCityList(1)"
                >
                  <el-option
                    v-for="item in CountyOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </div>

            <div class="form-address__city">
              <el-form-item prop="memberCity" class="form-field">
                <el-select
                  v-model="RegisterForm.memberCity"
                  :placeholder="$t('register.placeholder.city')"
                  size="large"
                  @change="SetZipCode()"
                >
                  <el-option
                    v-for="item in CityOption"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="form-address__address">
            <el-form-item prop="memberAddress" class="form-field">
              <el-input
                v-model="RegisterForm.memberAddress"
                :placeholder="$t('register.placeholder.detailAddress')"
                size="large"
                prefix-icon="el-icon-location-outline"
              />
            </el-form-item>
          </div>
        </div>

        <!-- 在學狀態 -->
        <el-form-item prop="inSchool" class="form-field form-field--checkbox">
          <label class="form-label">{{ $t('register.label.inSchool') }}</label>
          <el-radio-group v-model="RegisterForm.inSchool" class="form-radio">
            <el-radio class="form-radio" :label="1">{{ $t('common.yes') }}</el-radio>
            <el-radio class="form-radio" :label="0">{{ $t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 學校資訊 -->
        <div class="form-group">
          <label class="form-label">{{ $t('register.label.education') }}</label>
          <div class="form-education">
            <div class="form-education__schoolId">
              <el-form-item prop="schoolId" class="form-field">
                <el-select
                  v-model="RegisterForm.schoolId"
                  filterable
                  :placeholder="$t('register.placeholder.school')"
                  size="large"
                  @change="SetSchoolDept('RegisterForm')"
                >
                  <el-option
                    v-for="item in SchoolOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>

            <div class="form-education__schoolDeptId">
              <el-form-item prop="schoolDeptId" class="form-field">
                <el-select
                  v-model="RegisterForm.schoolDeptId"
                  filterable
                  :placeholder="$t('register.placeholder.department')"
                  size="large"
                  @change="SetZipCode()"
                >
                  <el-option
                    v-for="item in SchoolDeptOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>

            <div class="form-education__schoolYearId">
              <el-form-item
                v-if="RegisterForm.inSchool"
                prop="schoolYearId"
                class="form-field"
              >
                <el-select
                  v-model="RegisterForm.schoolYearId"
                  :placeholder="$t('register.placeholder.grade')"
                  size="large"
                  @change="SetZipCode()"
                >
                  <el-option
                    v-for="item in SchoolYearOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>

        <!-- 圖形驗證碼 -->
        <div class="form-group form-group--inline">
          <el-form-item prop="captchaCode" class="form-field form-field--flex">
            <label class="form-label">{{ $t('common.label.captcha') }}</label>
            <el-input
              v-model="RegisterForm.captchaCode"
              :placeholder="$t('common.placeholder.captcha')"
              size="large"
              prefix-icon="el-icon-picture"
            />
          </el-form-item>
          <div class="captcha-image" @click="GetCaptchaCode">
            <img :src="`data:image/png;base64,${CodeImg}`" alt="Captcha" />
          </div>
        </div>

        <!-- 同意條款 -->
        <div class="form-policy">
          <el-checkbox v-model="RegisterForm.IsCheck" :true-label="1" :false-label="0" class="form-radio">
            {{ $t('register.agreePolicy.prefix') }}
            <a href="/novices/policy" target="_blank">
              {{ $t('register.agreePolicy.link') }}
            </a>
          </el-checkbox>
        </div>

        <button
          class="btn-submit full"
          @click="RegisterMember"
        >
          {{ $t('common.button.submit') }}
        </button>

        <!-- 登入連結 -->
        <div class="form-footer">
          <span>{{ $t('register.alreadyMember') }}</span>
          <router-link to="/login" class="form-link form-link--primary">{{ $t('register.loginLink') }}</router-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  RegistMember,
  GetSchool,
  GetSchoolDept,
  GetSchoolYear,
} from '@/api/MemberApi';
import { GetCaptchaCode, GetCaptchaBase64 } from '@/api/CaptchaApi';
import { SendVerification } from '@/api/BaseApi';
import { GetCountyList, GetCityList } from '@/lib/zipcode';
import SchoolFunc from '@/lib/school';

export default {
  data() {
    return {
      IsCheck: 0, // 是否已詳閱隱私權條款
      CodeImg: '', // 圖形驗證碼使用的data
      RegisterForm: {
        memberId: 0,
        memberAccount: '',
        memberPassword: '',
        memberConfirmPassword: '',
        memberName: '',
        memberMail: '',
        memberPhone: '',
        memberZipCode: '',
        memberCounty: '',
        memberCity: '',
        memberAddress: '',
        isReceive: 1,
        status: 1,
        code: '',
        captchaCode: '',
        // 信箱認證
        mailVerificationCaptchaCode: '',
        mailVerificationGuid: '',
        // 手機認證
        phoneVerificationCaptchaCode: '',
        phoneVerificationGuid: '',
        // 學校資訊
        inSchool: '',
        schoolId: '',
        schoolDeptId: '',
        schoolYearId: '',
      },
      RegisterRules: {
        // 檢查輸入的值規則
        memberAccount: [
          { required: true, message: this.$t('common.message.accountRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.accountLength') },
        ],
        memberPassword: [
          { required: true, message: this.$t('common.message.passwordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.passwordLength') },
          {
            pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
            message: this.$t('validation.passwordFormat'),
            trigger: 'blur',
          },
        ],
        memberConfirmPassword: [
          { required: true, message: this.$t('validation.confirmPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.passwordLength') },
          {
            pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
            message: this.$t('validation.passwordFormat'),
            trigger: 'blur',
          },
        ],
        memberName: [
          { required: true, message: this.$t('validation.nameRequired'), trigger: 'blur' },
        ],
        memberMail: [
          { required: true, message: this.$t('validation.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('validation.emailFormat'), trigger: ['blur', 'change'] },
        ],
        memberPhone: [
          // { required: true, message: this.$t('validation.phoneRequired'), trigger: 'blur' },
          { min: 10, trigger: ['blur', 'change'], message: this.$t('validation.phoneLength') },
          {
            pattern: /^09[0-9]{8}$/,
            message: this.$t('validation.phoneFormat'),
            trigger: 'blur',
          },
        ],
        memberZipCode: [{ required: true, message: this.$t('validation.zipCodeRequired'), trigger: 'blur' }],
        memberCounty: [{ required: true, message: this.$t('validation.countyRequired'), trigger: 'change' }],
        memberCity: [{ required: true, message: this.$t('validation.cityRequired'), trigger: 'change' }],
        memberAddress: [{ required: true, message: this.$t('validation.addressRequired'), trigger: 'blur' }],
        captchaCode: [{ required: true, message: this.$t('validation.captchaRequired'), trigger: 'blur' }],
        mailVerificationCaptchaCode: [
          { required: true, message: this.$t('validation.emailCodeRequired'), trigger: 'blur' },
        ],
        // phoneVerificationCaptchaCode: [
        //   { required: true, message: this.$t('validation.phoneCodeRequired'), trigger: 'blur' },
        // ],
        inSchool: [{ required: true, message: this.$t('validation.inSchoolRequired'), trigger: ['blur', 'change'] }],
        schoolId: [{ required: true, message: this.$t('validation.schoolRequired'), trigger: ['blur', 'change'] }],
        schoolDeptId: [{ required: true, message: this.$t('validation.departmentRequired'), trigger: ['blur', 'change'] }],
        schoolYearId: [{ required: true, message: this.$t('validation.gradeRequired'), trigger: ['blur', 'change'] }],
      },
      mailTimer: '',
      mailTimerText: '',
      phoneTimer: '',
      phoneTimerText: '',
      CountyOption: [],
      CityOption: [],
      SchoolOption: [],
      SchoolDeptOption: [],
      SchoolYearOption: [],
      SchoolFunc: {
        GetSchool,
        GetSchoolYear,
        GetSchoolDept,
      },
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'RegisterForm.inSchool': function () {
      if (this.RegisterForm.inSchool === 0) {
        this.changeInSchool('RegisterForm');
      }
    },
  },
  created() {
    // 呼叫圖形驗證碼
    this.GetCaptchaCode();
    this.SetCountyList();
    this.SetCityList(0);

    this.GetSchoolList();
    this.GetSchoolYearList();

    // 初始化 timer text
    this.mailTimerText = this.$t('register.button.sendCode');
    this.phoneTimerText = this.$t('register.button.sendCode');
  },
  beforeRouteLeave(to, form, next) {
    this.ClearTimer('mail');
    this.ClearTimer('phone');
    next();
  },
  methods: {
    ...SchoolFunc,
    handleReplaceSpace() {
      this.RegisterForm.memberAccount = this.RegisterForm.memberAccount.replace(/\s+/g, '');
    },
    SetCountyList() {
      this.CountyOption = GetCountyList();
    },
    SetCityList(clear) {
      this.CityOption = GetCityList(this.RegisterForm.memberCounty);
      if (clear === 1) {
        this.RegisterForm.memberCity = '';
        this.RegisterForm.memberZipCode = '';
      } else {
        const data = this.CityOption.filter((item) => this.RegisterForm.memberCity === item.label);
        if (!data[0]) {
          this.RegisterForm.memberCity = '';
          this.RegisterForm.memberZipCode = '';
        }
      }
    },
    SetZipCode() {
      const data = this.CityOption.filter((item) => this.RegisterForm.memberCity === item.label);
      if (data[0]) {
        this.RegisterForm.memberZipCode = data[0].value;
      } else {
        this.RegisterForm.memberZipCode = '';
      }
    },
    // 取得驗證碼
    GetCaptchaCode() {
      GetCaptchaCode().then((response) => {
        if (response.data.statusCode === 0) {
          this.RegisterForm.code = response.data.data.code;
          GetCaptchaBase64(this.RegisterForm.code).then((res) => {
            this.CodeImg = res.data;
          });
        }
      });
    },
    RegisterMember() {
      this.$refs.RegisterForm.validate((valid) => {
        if (valid) {
          if (this.RegisterForm.IsCheck === 1) {
            if (this.RegisterForm.memberPassword === this.RegisterForm.memberConfirmPassword) {
              const form = this.RegisterForm;
              const postData = this._.cloneDeep(form);

              postData.schoolId = form.schoolId === '' ? 0 : form.schoolId;
              postData.schoolDeptId = form.schoolDeptId === '' ? 0 : form.schoolDeptId;
              postData.schoolYearId = form.schoolYearId === '' ? null : form.schoolYearId;

              RegistMember(this.RegisterForm).then((response) => {
                if (response.data.statusCode === 0) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: this.$t('register.message.success'),
                  });
                  this.$router.push('/Login');
                } else {
                  this.GetCaptchaCode();
                }
              });
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('register.message.passwordMismatch'),
              });
            }
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: this.$t('register.message.agreeRequired'),
            });
          }
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.fillAllFields'),
          });
        }
      });
    },
    GetVerification(type) {
      let boxName = 'memberMail';
      let checkValue = this.RegisterForm.memberMail;
      let typeName = 'mail';
      if (type === 2) {
        typeName = 'phone';
        checkValue = this.RegisterForm.memberPhone;
        boxName = 'memberPhone';
      }

      this.$refs.RegisterForm.validateField(boxName, (error) => {
        if (!error) {
          const postData = {
            VerificationType: type,
            VerificationData: checkValue,
          };
          SendVerification(postData).then((response) => {
            if (response.data.statusCode === 0) {
              this.StatrTimer(typeName);
              this.RegisterForm[`${typeName}VerificationGuid`] = response.data.data.verificationGuid;
            }
          });
        }
      });
    },
    StatrTimer(type) {
      const vm = this;
      const end = vm.$moment(new Date()).add(1, 'minutes');
      this.TiemrFunc(type, end);
      this[`${type}Timer`] = setInterval(() => this.TiemrFunc(type, end), 1000);
    },
    ClearTimer(type) {
      clearInterval(this[`${type}Timer`]);
    },
    TiemrFunc(type, end) {
      const now = new Date();
      const timeLeft = this.$moment(end).diff(now);
      const timeLeftFormat = this.$moment(timeLeft).format('mm:ss');
      if (timeLeft <= 0) {
        this.ClearTimer(type);
        this[`${type}TimerText`] = this.$t('register.button.sendCode');
      } else {
        this[`${type}TimerText`] = `${timeLeftFormat}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables';

.form-note {
  margin: 6px 0 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #dc632d;;

  @media (max-width: $breakpoint-sm) {
    font-size: 12px;
  }
}

.form-policy {
  margin-bottom: 24px;

  .el-checkbox {
    font-size: 14px;
    color: var(--text-secondary);

    a {
      color: var(--primary-color);
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
